import { io } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || undefined;

let socket = null;
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 5;

/**
 * Initialize WebSocket connection
 */
export function initSocket() {
  if (socket?.connected) {
    console.log('[Socket] Already connected');
    return socket;
  }

  console.log('[Socket] Connecting to', SOCKET_URL);

  socket = io(SOCKET_URL, {
    transports: ['polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
  });

  socket.on('connect', () => {
    console.log('[Socket] Connected:', socket.id);
    reconnectAttempts = 0;
  });

  socket.on('disconnect', (reason) => {
    console.log('[Socket] Disconnected:', reason);
  });

  socket.on('connect_error', (error) => {
    reconnectAttempts++;
    console.error('[Socket] Connection error:', error.message);

    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      console.error('[Socket] Max reconnection attempts reached');
      socket.close();
    }
  });

  socket.on('reconnect', (attemptNumber) => {
    console.log('[Socket] Reconnected after', attemptNumber, 'attempts');
    reconnectAttempts = 0;
  });

  return socket;
}

/**
 * Get the socket instance
 */
export function getSocket() {
  if (!socket) {
    return initSocket();
  }
  return socket;
}

/**
 * Disconnect socket
 */
export function disconnectSocket() {
  if (socket) {
    console.log('[Socket] Disconnecting');
    socket.close();
    socket = null;
  }
}

/**
 * Subscribe to an event
 */
export function on(event, callback) {
  const sock = getSocket();
  sock.on(event, callback);

  // Return unsubscribe function
  return () => sock.off(event, callback);
}

/**
 * Emit an event
 */
export function emit(event, data) {
  const sock = getSocket();
  sock.emit(event, data);
}

// WebSocket event constants (should match backend)
export const WS_EVENTS = {
  EMAIL_PROCESSED: 'email:processed',
  SYNC_STARTED: 'sync:started',
  SYNC_COMPLETED: 'sync:completed',
  SYNC_ERROR: 'sync:error',
  AGENT_STATUS: 'agent:status',
};
